import React, { useState } from 'react';

const RandomNumberTable = () => {
  const [numValues, setNumValues] = useState(10); // Default to 10 random numbers
  const [minValue, setMinValue] = useState(1);    // Default minimum value
  const [maxValue, setMaxValue] = useState(100);  // Default maximum value
  const [randomNumbers, setRandomNumbers] = useState([]);

  // Function to generate a random number between min and max
  const generateRandomNumber = (min, max) => {
    return (Math.random() * (max - min) + min).toFixed(4); // Rounded to 4 decimals
  };

  // Function to generate the random numbers table
  const generateRandomNumbersTable = () => {
    if (minValue >= maxValue) {
      alert("Minimum value must be less than Maximum value.");
      return;
    }

    const numbers = [];
    for (let i = 0; i < numValues; i++) {
      const randomNum = generateRandomNumber(minValue, maxValue);
      numbers.push(randomNum);
    }
    setRandomNumbers(numbers);
  };

  return (
    <div>
      <h2>Random Numbers Table</h2>
      <label htmlFor="numValues">Number of Values: </label>
      <input
        type="number"
        id="numValues"
        value={numValues}
        min="1"
        onChange={(e) => setNumValues(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="minValue">Minimum Value: </label>
      <input
        type="number"
        id="minValue"
        value={minValue}
        onChange={(e) => setMinValue(parseFloat(e.target.value))}
      />
      <br />
      <label htmlFor="maxValue">Maximum Value: </label>
      <input
        type="number"
        id="maxValue"
        value={maxValue}
        onChange={(e) => setMaxValue(parseFloat(e.target.value))}
      />
      <br />
      <button onClick={generateRandomNumbersTable}>Generate Table</button>

      {randomNumbers.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Index</th>
              <th>Random Number</th>
            </tr>
          </thead>
          <tbody>
            {randomNumbers.map((randomNum, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{randomNum}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default RandomNumberTable;
